import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/GalleryCard.css';

const GalleryCard = ({ gallery, currentUser }) => {
  // Format date for events display
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Get next upcoming event if available
  const nextEvent = gallery.upcoming_events && gallery.upcoming_events.length > 0 
    ? gallery.upcoming_events[0] 
    : null;

  return (
    <div className="gallery-card bg-white rounded-lg shadow overflow-hidden">
      <div className="relative">
        <Link to={`/gallery/${gallery.gallery_id}`}>
          <img 
            src={gallery.cover_image || 'https://images.unsplash.com/photo-1507643179773-3e975d7ac515?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NTYyMDF8MHwxfHNlYXJjaHwxfHxnYWxsZXJ5fGVufDB8fHx8MTc0MTQ1Njk0NXww&ixlib=rb-4.0.3&q=80&w=400'} 
            alt={gallery.name} 
            className="w-full h-48 object-cover"
          />
        </Link>
        
        {/* Event badge if applicable */}
        {nextEvent && (
          <div className="absolute top-2 right-2 event-badge">
            {new Date(nextEvent.event_start).toDateString() === new Date().toDateString() 
              ? 'Event Today' 
              : 'Upcoming Event'}
          </div>
        )}
        
        {/* Followed badge if applicable */}
        {currentUser && gallery.followed_by_user && (
          <div className="absolute top-2 left-2 followed-badge">
            Following
          </div>
        )}
      </div>
      
      <div className="p-4">
        <Link to={`/gallery/${gallery.gallery_id}`} className="no-underline text-gray-900">
          <h3 className="font-bold text-lg mb-1">{gallery.name}</h3>
        </Link>
        
        <p className="text-gray-500 text-sm mb-2">
          {gallery.type} • {gallery.distance}
        </p>
        
        {/* Art type tags */}
        <div className="flex flex-wrap gap-1 mb-3">
          {gallery.artworks && gallery.artworks.length > 0 && 
            gallery.artworks.slice(0, 2).map(artwork => 
              artwork.artwork_types && artwork.artwork_types.slice(0, 2).map(type => (
                <span key={`${artwork.vc_id}-${type}`} className="tag-pill">{type}</span>
              ))
            )
          }
        </div>
        
        <p className="text-gray-700 text-sm mb-3 line-clamp-2">
          {gallery.description || 'A local gallery showcasing diverse artistic works.'}
        </p>
        
        {/* Next event information */}
        {nextEvent && (
          <div className="flex items-center text-sm text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
            </svg>
            <span>
              {nextEvent.name}: {new Date(nextEvent.event_start).toLocaleDateString()}, {formatEventDate(nextEvent.event_start)}
            </span>
          </div>
        )}
        
        {/* If no events but gallery is open, show hours */}
        {!nextEvent && (
          <div className="flex items-center text-sm text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Open Today: 11:00 AM - 7:00 PM</span>
          </div>
        )}
        
        {/* Action buttons for logged in users */}
        {currentUser && (
          <div className="mt-3 flex justify-end space-x-2">
            {gallery.followed_by_user ? (
              <button className="text-xs px-2 py-1 bg-indigo-100 text-indigo-700 rounded">
                Following
              </button>
            ) : (
              <button className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-indigo-100 hover:text-indigo-700">
                Follow
              </button>
            )}
            
            <button className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-indigo-100 hover:text-indigo-700">
              View in 3D
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryCard;